import api from './api';

export interface SubscriptionStatus {
  subscriptionTier: 'free' | 'premium';
  isSubscriptionActive: boolean;
  subscriptionExpiresAt?: string;
  subscriptionCancelled?: boolean;
  subscriptionCancelledAt?: string;
  subscriptionValue?: number;
  subscriptionInterval?: 'month' | 'year';
  oneDayPassActive?: boolean;
  oneDayPassExpiresAt?: string;
  usage: {
    deckCount: number;
    monthlyStudyTime: number;
    monthlyCardsStudied: number;
  };
  limits: {
    maxDecks: number;
    maxCardsPerDeck: number;
    totalCards: number;
  };
}

export interface CreateCheckoutSession {
  priceId: string;
  successUrl: string;
  cancelUrl: string;
}

export interface CreateOneDayPassCheckout {
  successUrl: string;
  cancelUrl: string;
}

export interface ConfirmPixPayment {
  paymentMethod: 'pix';
}

export interface PixPaymentResponse {
  success: boolean;
  message: string;
  expiresAt: string;
}

export const subscriptionService = {
  async getStatus(): Promise<SubscriptionStatus> {
    const response = await api.get('/subscription/status');
    return response.data;
  },

  async createCheckoutSession(data: CreateCheckoutSession): Promise<{ url: string }> {
    const response = await api.post('/subscription/create-checkout-session', data);
    return response.data;
  },

  async createOneDayPassCheckout(data: CreateOneDayPassCheckout): Promise<{ url: string }> {
    const response = await api.post('/subscription/create-one-day-pass-checkout', data);
    return response.data;
  },

  async confirmPixPayment(data: ConfirmPixPayment): Promise<PixPaymentResponse> {
    const response = await api.post('/subscription/confirm-pix-payment', data);
    return response.data;
  },

  async cancelSubscription(): Promise<{ 
    message: string; 
    contactEmail?: string; 
    instructions?: string; 
  }> {
    const response = await api.delete('/subscription/cancel');
    return response.data;
  }
};
